import React, { LabelHTMLAttributes } from 'react';
import classnames from 'classnames';
import s from './InputLabel.scss';

interface Props extends LabelHTMLAttributes<HTMLLabelElement> {}

/**
 * Renders children in a `<label />`. This is a necessary element of all form elements.
 */
const InputLabel: React.FC<Props> = ({ children, className, ...rest }) => {
  return (
    <label className={classnames(s['root'], className)} {...rest}>
      {children}
    </label>
  );
};
InputLabel.displayName = 'InputLabel';

export default InputLabel;
